import {observable, decorate, action} from 'mobx';
import {Cookies} from "react-cookie";

class CookieStore {
    cookies = null;
    constructor() {
        this.cookies = new Cookies();
    }

    getAllCookie() {
        return this.cookies.getAll();
    }

    getCookie(name) {
        return this.cookies.get(name);
    }

    setCookie(name, value) {
        return this.cookies.set(name, value);
    }
    removeCookie(name) {
        this.cookies.remove(name);
    }
}

decorate(CookieStore, {
    cookies: observable,
    getCookie: action,
    removeCookie: action,
});

export default CookieStore;